import { BadgeCheck, Sparkles, ShieldCheck } from "lucide-react";

const TIERS = {
  community: {
    label: "Community verified",
    icon: Sparkles,
    color: "text-[#3B5A6B]",
    bg: "bg-[#3B5A6B]/10 border border-[#3B5A6B]/40",
  },
  admin: {
    label: "Verified employer",
    icon: BadgeCheck,
    color: "text-[#DDA74A]",
    bg: "bg-[#DDA74A]/15 border border-[#DDA74A]/40",
  },
  id: {
    label: "ID-verified",
    icon: ShieldCheck,
    color: "text-[#1E3A2F]",
    bg: "bg-[#1E3A2F]/10 border border-[#1E3A2F]/40",
  },
};

export default function VerifiedBadge({ tier = "admin", verified = true, size = "md", className = "" }) {
  if (!verified && !TIERS[tier]) return null;
  const t = TIERS[tier] || TIERS.admin;
  const Icon = t.icon;
  const py = size === "sm" ? "py-0.5" : "py-1";
  const px = size === "sm" ? "px-2" : "px-2.5";
  const text = size === "sm" ? "text-[10px]" : "text-xs";
  return (
    <span
      data-testid={`verified-badge-${tier}`}
      title={t.label}
      className={`inline-flex items-center gap-1 rounded-full font-medium ${text} ${px} ${py} ${t.bg} ${t.color} ${className}`}
    >
      <Icon className="w-3.5 h-3.5" />
      <span>{t.label}</span>
    </span>
  );
}

export const VERIFICATION_TIERS = [
  { key: "none", label: "None" },
  { key: "community", label: "Community verified" },
  { key: "admin", label: "Verified employer" },
  { key: "id", label: "ID-verified" },
];
